<template>
  <div>
    <div
      style="display: flex; flex-direction: column; gap: 12px; padding: 32px"
    >
      <div
        style="
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
        "
      >
        {{ $t("i18n_my_bills") }}
      </div>
      <!-- <div style="min-width: 1200px">
        <el-row :gutter="20">
          <el-col style="min-width:450px;margin-bottom:20px" :span="8">
            <div class="grid-content bg-purple" style="width:450px">
              <span
                style="width:80px
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-right: 20px;
                "
              >
                支付时间
              </span>
              <el-date-picker
                @change="pickerChange"
                v-model="value1"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="8" style="margin-bottom:20px">
            <div
              class="grid-content bg-purple"
              style="display: flex; align-items: center"
            >
              <span
                style="
                  font-size: 14px;
                  min-width: 50px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-right: 20px;
                "
              >
                账单号
              </span>
              <el-input
                placeholder="请输入账单号"
                clearable
                v-model="id"
                style="width: 240px"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <span
                style="
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-right: 20px;
                "
              >
                账单状态
              </span>
              <el-select
                style="width: 107px"
                v-model="state"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.state"
                  :label="item.name"
                  :value="item.state"
                >
                </el-option>
              </el-select>

              <el-button
                @click="getListByParams(1)"
                style="margin-left: 20px"
                type="primary"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div> -->
      <div
        style="
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          column-gap: 10px;
        "
      >
        <div class="grid-content bg-purple">
          <span
            style="
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 10px;
            "
          >
            {{ $t("i18n_cost_generated_time") }}
          </span>
          <el-date-picker
            @change="pickerChange"
            v-model="value1"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="$t('i18n_started_date')"
            :end-placeholder="$t('i18n_end_date')"
          >
          </el-date-picker>
        </div>
        <div
          class="grid-content bg-purple normal"
          style="display: flex; align-items: center"
        >
          <span
            style="
              width: 62px;
              line-height: 32px;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 10px;
            "
          >
            {{ $t("i18n_invoice_number") }}
          </span>
          <el-input
            :placeholder="$t('i18n_please_enter')"
            v-model="id"
            clearable
          >
          </el-input>
        </div>
        <div
          class="grid-content bg-purple normal"
          style="display: flex; align-items: center"
        >
          <span
            style="
              width: 42px;
              line-height: 32px;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 10px;
            "
          >
            {{ $t("i18n_tracking_number") }}
          </span>
          <el-input
            :placeholder="$t('i18n_please_enter')"
            v-model.trim="nos"
            clearable
          >
          </el-input>
        </div>
        <div class="grid-content bg-purple normal">
          <span
            style="
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 10px;
            "
          >
            {{ $t("i18n_bill_status") }}
          </span>
          <el-select v-model="state" :placeholder="$t('i18n_please_choose')">
            <el-option
              v-for="item in statusList"
              :key="item.state"
              :label="$t(item.name)"
              :value="item.state"
            >
            </el-option>
          </el-select>

          <el-button
            @click="getListByParams(1)"
            style="
              width: 62px;
              height: 32px;
              line-height: 32px;
              padding: 0px;
              margin-left: 20px;
            "
            type="primary"
            >{{ $t("i18n_tracking") }}</el-button
          >
        </div>
      </div>
      <div style="margin-top: 10px">
        <el-table
          ref="multipleTable"
          align="center"
          :header-cell-style="{
            background: '#eef1f6',
            color: '#606266'
          }"
          border
          highlight-current-row
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            width="60"
            align="center"
            :label="$t('i18n_Serial_number')"
            type="index"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="billNo"
            :label="$t('i18n_invoice_number')"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="nos"
            :label="$t('i18n_tracking_number')"
          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="amount"
            :label="$t('i18n_Payment_amount')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.amount }} {{ scope.row.currency }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createBillTime"
            :label="$t('i18n_invoices_generated_time')"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="state"
            :label="$t('i18n_invoice_status')"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.state == 'I'">{{
                $t("i18n_waiting_for_payment")
              }}</span>
              <span v-if="scope.row.state == 'C'">{{
                $t("i18n_waiting_for_confirmation")
              }}</span>
              <span v-if="scope.row.state == 'S'">{{
                $t("i18n_completed")
              }}</span>
              <span v-if="scope.row.state == 'D'">{{
                $t("i18n_cancelled")
              }}</span>
              <span v-if="scope.row.state == 'P'">{{
                $t("i18n_partial_payment")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="payTime"
            :label="$t('i18n_Payment_Time')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.payTime ? scope.row.payTime : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="payType"
            :label="$t('i18n_Payment_Method')"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.payType == 'B'">{{
                $t("i18n_WeChat_Pay")
              }}</span>
              <span v-else-if="scope.row.payType == 'A'">{{
                $t("i18n_Alipay_payment")
              }}</span>
              <span v-else-if="scope.row.payType == 'C'">{{
                $t("i18n_Offline")
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('i18n_Operation')">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center">
                <router-link
                  :to="{
                    name: 'PayDetail',
                    query: {
                      id: scope.row.id,
                      state: scope.row.state,
                      billNo: scope.row.billNo,
                      amount: scope.row.amount
                    }
                  }"
                >
                  <span style="color: #9a9a9a" class="myCursor">{{
                    $t("i18n_view_details")
                  }}</span>
                </router-link>
                <div style="width: 60px">
                  <div
                    v-if="scope.row.isHaveImg"
                    style="color: #604aff; margin-left: 20px; width: 60px"
                    class="myCursor"
                    @click="checkPic(scope.row.id)"
                  >
                    {{ $t("i18n_check_payment_receipt") }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px; float: left"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <div style="clear: both"></div>
      </div>
      <el-dialog
        :title="$t('i18n_payment_information')"
        :visible.sync="shwoPics"
        width="50%"
        center
      >
        <div style="height: 500px; overflow: overlay">
          <div
            style="text-align: center"
            v-for="(url, index) in picPaths"
            :key="index"
          >
            <img
              @click="openPic(url)"
              :src="url"
              style="width: 100%; margin-top: 5px; cursor: pointer"
              alt=""
            />
            <!-- <el-image style="width: 100%;margin-top:5px" fit="contain"
             :src="url" lazy></el-image>      -->
            <el-tag v-if="picPaths.length > 1">{{
              $tc("i18n_No_of_picture", index + 1, { count: index + 1 })
            }}</el-tag>
          </div>
          <el-dialog :modal="false" :visible.sync="dialogVisible1">
            <div style="text-algin: center; position: relative">
              <img
                ref="imgRef"
                style="width: 100%; height: 100%; max-height: 500px"
                :src="dialogImageUrl"
                alt=""
              />

              <div
                style="
                  bottom: 10%;
                  zoom: 50%;
                  position: absolute;
                  opacity: 0.4;
                  width: 100%;
                  text-align: center;
                  z-index: 1;
                "
              >
                <el-button
                  style="width: 100px"
                  type="primary"
                  @click="rotate()"
                  >{{ $t("i18n_Rotation") }}</el-button
                >
                <el-button
                  style="width: 100px"
                  type="primary"
                  @click="rotate('big')"
                  >{{ $t("i18n_Enlarge") }}</el-button
                >
                <el-button
                  style="width: 100px"
                  type="primary"
                  @click="rotate('small')"
                  >{{ $t("i18n_zoom_out") }}</el-button
                >
                <el-button
                  style="width: 100px"
                  type="primary"
                  @click="closePic()"
                  >{{ $t("i18n_Close") }}</el-button
                >
              </div>
            </div>
          </el-dialog>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="shwoPics = false">{{
            $t("i18n_Return")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible1: false,
      deg: 0,
      scale: 0,
      id: "",
      prefix: "",
      beginTime: "",
      tableData: [],
      multipleSelection: [],
      billBeginTime: "",
      billEndTime: "",
      billNo: "",
      state: "",
      statusList: [
        {
          name: "i18n_All",
          state: "",
        },
        {
          name: "i18n_waiting_for_payment",
          state: "I",
        },
        {
          name: "i18n_waiting_for_confirmation",
          state: "C",
        },
        {
          name: "i18n_completed",
          state: "S",
        },
        {
          name: "i18n_partial_payment",
          state: "P",
        },
        // {
        //   name: "已作废",
        //   state: "D",
        // },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      value1: [],
      nos: "",
      shwoPics: false,
      picPaths: [],
      fileList: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }]

    };
  },
  watch: {},
  methods: {
    closePic() {
      this.dialogVisible1 = false
      this.dialogImageUrl = ''
      this.$refs.imgRef.style.transform = ''
      this.scale = 0
      this.deg = 0
    },
    openPic(url) {
      this.dialogImageUrl = url
      this.dialogVisible1 = true
    },
    rotate(type) {
      if (type == 'big') {
        if (this.scale > 5) {
          this.$message.info(this.$t('i18n_already_biggest'))
          return
        }
        this.scale++
        this.$refs.imgRef.style.transform = `rotate(0deg) scale(1.${this.scale})`
        return
      }
      if (type == 'small') {
        if (this.scale <= 0) {
          this.$message.info(this.$t('i18n_already_smallest'))
          return
        }
        this.scale--
        this.$refs.imgRef.style.transform = `rotate(0deg) scale(1.${this.scale})`
        return
      }
      if (this.deg >= 360) {
        this.deg = 0
        this.deg += 90
        this.$refs.imgRef.style.transform = `rotate(${this.deg}deg) scale(1.${this.scale})`
      } else {
        this.deg += 90
        this.$refs.imgRef.style.transform = `rotate(${this.deg}deg) scale(1.${this.scale})`
      }
    },
    pickerChange(e) {
      console.log(this.value1);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1
      this.getListByParams();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getListByParams();
    },
    // 获取水单
    checkPic(id) {
      this.axios
        .get("/arap/getTransferVoucher/" + id)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas.length > 0) {
              this.shwoPics = true;
              this.picPaths = res.data.datas
              return
            }
            this.$message.info(res.data.message)
            return;
          }
          this.$message.info(res.data.message);
        })
        .catch((res) => { });
    },

    getDetail(id) {
      this.$router.push("PayDetail?id=" + id);
      return;
      this.axios
        .get("/arap/getFinaBillWebSingleList/" + "18939962000")
        .then((res) => { })
        .catch((res) => { });
    },
    // 根据参数查询
    getListByParams(type) {
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      let param = {
        billBeginTime: "",
        billEndTime: "",
        billNo: "",
        curPage: this.currentPage,
        customerId: user.customerid,
        nos: this.nos,
        pageSize: this.pageSize,
        startIndex: 0,
        state: "",
      };
      if (type == 1) {
        param.curPage = 1;
      }
      if (this.value1 == null) {
      } else {
        if (this.value1.length > 1) {
          param.billBeginTime = this.value1[0];
          param.billEndTime = this.value1[1];
        }
      }
      if (this.id) {
        param.billNo = this.id.trim();
      }
      if (this.state) {
        param.state = this.state;
      }

      this.axios
        .post("/arap/getFinaBillWebList", param)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.datalList.length > 0) {
              this.tableData = res.data.data.datalList;
              this.total = res.data.data.totalCounts;

              return;
            }
            this.$message.info(this.$t("i18n_No_data"));
            this.tableData = [];
            this.total = res.data.data.totalCounts;
            return;
          }
          this.$message.info(res.data.message);
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getList() {
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);

      this.axios
        .post("/arap/getFinaBillWebList", {
          billBeginTime: "",
          billEndTime: "",
          billNo: "",
          curPage: this.currentPage,
          customerId: user.customerid,
          pageSize: this.pageSize,
          startIndex: 0,
          state: "",
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.datalList;
            this.total = res.data.data.totalCounts;

            return;
          }
          this.$message.info(res.data.message);
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    toPay() {
      this.$router.push("/index/Personalindex/payOrder");
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      console.log(val);
    },
  },
  created() {
    this.getList();
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.tableBorderMy {
  border: 1px solid #e7e7e7;
}
.tableBorderMyBtn {
  border-bottom: 1px solid #e7e7e7;
}
.myCursor {
  cursor: pointer;
}

/deep/.el-table td,
/deep/ .el-table th {
  padding: 8px 0px;
}

/deep/ .bg-purple .el-input__inner {
  width: 262px;
  height: 32px;
  line-height: 32px;
}

/deep/ .normal .el-input__inner {
  width: 216px;
  height: 32px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/billType/PayRecord.vue